import {Link, redirect, useLoaderData, useParams} from "react-router-dom";
import HttpRequest from "../../../services/Request";
import TournamentComponent from '../../../components/Tournament'
import Cookies from "js-cookie";
import BackButton from "../../../components/BackButton";


const Show = () => {
    const params = useParams();
    const {tournament, post, canUpdate} = useLoaderData();
    const user = post.user
    const url = `/tournament/${params.id}/team/posts/${params.post_id}/edit`

    function showItem(title, value) {
        return <div
            className={`w-full md:w-[30%] md:mx-auto flex mt-2 justify-between`}>
            <span className={`text-orange text-[15px] font-bold`}>{title}</span>
            <span className={`text-[15px]`}>{value}</span>
        </div>;
    }

    return <div>
        <BackButton src={`/tournament/${params.id}/team/posts`} />
        <div className="flex items-center">
            <TournamentComponent tournament={tournament}/>
        </div>
        <div className="flex items-center mt-2">
            <div
                className="flex flex-wrap w-[97%]  md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 p-2 py-5">
                <div
                    className="w-[80%] md:w-[27%] md:mt-5 text-center p-3 mx-auto shadow mt-3 bg-gray2 text-orange">
                    <img src="/icons/icon-4.png" className="inline me-3 w-[25px] h-[25px]"/>
                    مدیریت نفرات تیم
                </div>
            </div>
        </div>
        <div className="flex items-center mt-2">
            <div
                className="flex flex-wrap w-[97%] md:w-[90%] rounded-[15px] mx-auto mt-1 md:mt-0 md:mb-2 bg-white p-2 py-5">
                <div
                    className="w-[80%] rounded-lg md:w-[22%] md:mt-5 text-center p-2 px-[2%] md:pr-[2%] mx-auto flex items-center shadow mt-3 bg-gray2 text-white font-bold">
                    <img src={post.user.image} className="me-3 w-[35px] h-[35px]"/>
                    <div className="flex flex-col justify-around items-start">
                        <span className="text-[12px] text-orange">{user.name + ' ' + user.lastname}</span>
                        <span className="text-[15px]">{post.name}</span>
                    </div>
                    {canUpdate === true && <Link className="mr-[40%] md:mr-[30%]" to={url}>
                        <img src={`/icons/edit-btn.png`} className=" w-[30px] h-[30px]"/>
                    </Link>}
                </div>
                <div
                    className="w-[80%] mx-auto mt-3 py-1 flex flex-wrap ">
                    {showItem('کد ملی', user.national_code)}
                    {showItem('شماره شناسنامه', user.id_number)}
                    {showItem('نام پدر', user.father_name)}
                    {showItem('تاریخ تولد', user.birthday)}
                    {showItem('محل صدور شناسنامه', user.city)}
                    {showItem('سابقه کار', user.work_experience)}
                    {showItem('موبایل', user.mobile)}
                    {showItem('ایمیل', user.email)}
                    {showItem('جنسیت', user.gender)}
                    {showItem('قد', user.height)}
                    {showItem('وزن', user.weight)}
                    {showItem('مقطع تحصیلی', user.education_level)}
                    {showItem('رشته تحصیلی', user.field_of_study)}
                    {user.image &&
                        <div
                            className={`w-full md:w-[30%] md:mx-auto flex flex-col my-2`}>
                            <p className={`text-orange text-[15px] font-bold`}>عکس 3×4</p>
                            <div className={`text-center mt-2`}>
                                <img src={user.image} className={`max-w-[200px] mx-auto rounded`} alt="عکس 3x4"/>
                            </div>
                        </div>
                    }
                    <div
                        className={`w-full md:w-[30%] md:mx-auto flex flex-col my-2`}>
                        <p className={`text-orange text-[15px] font-bold`}>گواهینامه ها</p>
                        <a target={`_blank`} href={user.certificates}>
                            <p className={`text-center bg-gray2 text-white py-2 font-bold rounded mt-2 font-[1.5em]`}>دانلود</p>
                        </a>
                    </div>
                    <div
                        className={`w-full md:w-[30%] md:mx-auto flex flex-col my-2`}>
                        <p className={`text-orange text-[15px] font-bold`}>سابقه بیمه و تاییدیه مدیر HSE</p>
                        <a target={`_blank`} href={user.insurance_history}>
                            <img className={`mt-2`} src={user.insurance_history} alt=""/>
                        </a>
                    </div>
                    {canUpdate === true &&
                        <div
                            className={`w-full  my-2`}>
                            <div className={`w-[90%] md:w-[30%] mx-auto text-center`}>
                                <Link to={url}
                                      className={`bg-gray2 inline-block text-center rounded py-3 w-[60%] text-white`}>
                                    ویرایش
                                </Link>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    </div>
}

export default Show

export async function ShowPageLoader({params}) {
    let data = []
    const url = `${process.env.REACT_APP_DOMAIN}/tournament/${params.id}/team/post/${params.post_id}/show`;
    try {
        await HttpRequest(url, (res) => {
                data = res.data;
            }, 'get', [], (err) => {
                let error = new Error();
                error.status = err.response.status
                throw error
            }
        )
    } catch (err) {
        if (err.status === 401) {
            Cookies.remove('access_token')
            return redirect('/login')
        }
    }
    return data;
}